export const MENU_CATEGORIES = [
    { id: 'all', label: 'Tout' },
    { id: 'poulet', label: 'Poulet' },
    { id: 'salade', label: 'Salade' },
    { id: 'accompagnement', label: 'Accompagnement' },
    { id: 'grillade', label: 'Grillade' },
    { id: 'menu', label: 'Menu' },
    { id: 'jus', label: 'Jus' },
    { id: 'boissons', label: 'Boissons' }
];

export const TITLE_MAP = {
    'poulet': 'Poulet',
    'salade': 'Salade',
    'accompagnement': 'Accompagnement',
    'grillade': 'Grillade',
    'menu': 'Menu',
    'jus': 'Jus',
    'boissons': 'Boissons'
};
